import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarVerracosExcel`, method: 'POST', body: value, token: token})
}
